module.exports = __webpack_public_path__ + "static/app-store-icon-apple-1e46c6e899aaab74e55c3ec60ae18018.png";